var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui-color" },
    [
      _c("input", {
        staticClass: "f-input",
        attrs: { type: "text" },
        domProps: { value: _vm.value },
        on: { change: _vm.change }
      }),
      _vm._v(" "),
      _c("a", {
        staticClass: "color",
        style: { background: _vm.value },
        on: { click: _vm.toggle }
      }),
      _vm._v(" "),
      _c("picker", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.picker,
            expression: "picker"
          },
          {
            name: "outside",
            rawName: "v-outside",
            value: _vm.hide,
            expression: "hide"
          }
        ],
        staticClass: "picker u-tile",
        attrs: { value: _vm.value },
        on: { input: _vm.input }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }